module.exports = __webpack_public_path__ + "img/frameBackground.49d1216d.png";